// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__3SgGS","message":"Loading_message__3DTTj"};